<div class="mat-snackbar"
     [ngClass]="{'mat-snackbar__success': data.type === 1, 'mat-snackbar__error': data.type === 0}">
    <div class="mat-snackbar__message">
        {{data.message}}
    </div>
</div>
